import * as _4 from 'lodash4';
import { PriorityFeedCapabilityConfiguration } from '../../configuration';
import { STCConfigsModel } from '../../models/stcconfigs_model';
import { ICommand } from 'core-ts-types';
import { SelfAlertIconDetailsQuery } from '../../queries/self_alert_icon_details_query';

export class QuickAddController {
  private initial: string;
  private isQuickAddMenuOpen: boolean = false;
  private isMobile: boolean;
  private showQuickAdd: boolean = false;
  private isAppointmentEnabled: boolean;
  private isReminderEnabled: boolean;
  private isSelfAlertEnabled: boolean;
  private isStudentFeedbackEnabled: boolean;
  private showSelfAlert: boolean = false;

  constructor(
    private $state: ng.ui.IStateService,
    private $scope: ng.IScope,
    private ngPriorityFeedCapabilityConfiguration: PriorityFeedCapabilityConfiguration,
    private openOpenableElementCommand: ICommand,
    private ngSelfAlertIconDetailsQuery: SelfAlertIconDetailsQuery,
    private ngSTCConfigsModel: STCConfigsModel
  ) {
    this.isMobile = this.ngPriorityFeedCapabilityConfiguration.config.isMobile;
    this.isAppointmentEnabled = this.ngPriorityFeedCapabilityConfiguration.config.isAppointmentEnabled;
    this.isReminderEnabled = this.ngPriorityFeedCapabilityConfiguration.config.isReminderEnabled;
    // As we add more features to quick add, modify this check
    this.showQuickAdd = this.isAppointmentEnabled || this.isReminderEnabled;
    this.isSelfAlertEnabled = this.ngPriorityFeedCapabilityConfiguration.config.isSelfAlertEnabled;
    this.isStudentFeedbackEnabled = this.ngPriorityFeedCapabilityConfiguration.config.isStudentFeedbackEnabled;
    $scope.quickAddButtonGid = 'quick-add-button-' + _4.uniqueId();
  }

  resetQuickAddMenu() {
    this.isQuickAddMenuOpen = false;
  }

  toggleQuickAddMenu() {
    this.isQuickAddMenuOpen = !this.isQuickAddMenuOpen;
  }

  goToScheduleAppointment() {
    this.resetQuickAddMenu();
    window.location.assign('#/my/host/as3/appointment-new');
  }

  goToAddPersonalToDo() {
    this.resetQuickAddMenu();
    this.$state.go('my.newreminder');
  }

  openSelfAlert() {
    this.resetQuickAddMenu();
    this.openOpenableElementCommand('selfAlertDialog');
  }

  openStudentFeedback() {
    this.resetQuickAddMenu();
    this.openOpenableElementCommand('studentFeedbackDialog');
  }

  getSelfAlertLabel() {
    return this.ngSTCConfigsModel.read().self_alert_label;
  }
}
export class QuickAddComponent implements ng.IComponentOptions {
  public controller: object = QuickAddController;
  public templateUrl: string = 'capability-ng-priority-feed/src/components/quick_add/quick_add.html';
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/components/quick_add/quick_add.ts